var map = {
	"./terms-DE": 600039,
	"./terms-DE.js": 600039,
	"./terms-EN": 434643,
	"./terms-EN.js": 434643,
	"./terms-ES": 83064,
	"./terms-ES.js": 83064,
	"./terms-NL": 128466,
	"./terms-NL.js": 128466,
	"./terms-PT": 966132,
	"./terms-PT.js": 966132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 928697;